<div class="flex" [formGroup]="form">
  <mat-form-field floatLabel="always" subscriptSizing="fixed" class="mr1">
    <mat-label>{{ schema()?.title || 'Value' }}</mat-label>
    <input
      matInput
      type="number"
      formControlName="amount"
      [attr.min]="0"
      step="1"
      (blur)="onBlur()"
      [placeholder]="schemaDefaultValue()"
    />
    @if (form.controls.amount.hasError('min')) {
      <mat-error>Value must be 0 or higher.</mat-error>
    }
  </mat-form-field>

  <mat-form-field floatLabel="always" subscriptSizing="fixed">
    <mat-label>Unit / Keyword</mat-label>
    <mat-select formControlName="unitOrKeyword" (selectionChange)="onBlur()">
      <mat-option [value]="noneUnitOrKeyword" matTooltip="Applies the template defaults"
        >None (Applies template default)</mat-option
      >
      <mat-optgroup label="Units">
        @for (unit of units; track unit) {
          <mat-option [value]="unit">{{ unit }}</mat-option>
        }
      </mat-optgroup>
      <mat-optgroup label="Keywords">
        @for (keyword of keywords; track keyword) {
          <mat-option [value]="keyword">{{ keyword }}</mat-option>
        }
      </mat-optgroup>
    </mat-select>
    @if (form.controls.unitOrKeyword.hasError('invalidSelection')) {
      <mat-error>Select a unit or keyword, or clear the value.</mat-error>
    }
  </mat-form-field>
</div>
